<!-- 由 Dioa 创建于 2022-10-21 Friday -->
<template>
  <div>
    <div class="download" v-if="!isApp">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="center">
        <div class="text1">betterWE星球</div>
        <div class="text2">一站式真人营养师服务平台</div>
      </div>
      <div class="btn">
        <span>打开看看</span>
        <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
    </div>

    <div class="lowcode-active" :style="fStyle(lowcodeData.canvasStyle)">
      <template v-for="item in fComponentStyle(lowcodeData.drawComponentList)">
        <component
          :key="item.id"
          class="component-preview-item"
          :class="
            item.animations
              ? `animate__animated animate__${item.animations}`
              : ''
          "
          :is="item.component"
          :data-id="item.id"
          :componentId="item.id"
          :propValue="item.propValue"
          :styles="{ ...fStyle(item.style) }"
          :config="item['config'] ? item.config : {}"
          @click.native="onEvent(item.events, item.component, $event, item)"
          @play.native="onPlay(item)"
        ></component>
      </template>

      <download-dialog
        :visible.sync="downloadShow"
        :shareLink="shareLink"
        @save="saveImage"
      />
    </div>

    <div class="back-float-ball" v-if="!postShow" @click="onClickBack">
      返回
    </div>

    <div class="download-btn" v-if="!isApp">
      <span>App 内打开</span>
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
    </div>

    <ShareComponent
      v-model="showShare"
      :posterUrl="posterUrl"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />

    <div id="a-poster" v-if="postShow" style="width: 100%">
      <div class="post-wrapper">
        <div class="top-info-wrapper">
          <div class="left-wrapper">
            <img
              class="title-image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
              alt=""
            />
            <div class="title-desc">
              <div class="title-desc-1">betterWE 星球</div>
              <div class="title-desc-2">一站式真人营养师服务平台</div>
            </div>
          </div>
          <div class="right-wrapper">
            <img
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_poster_top_logo"
              alt=""
            />
          </div>
        </div>

        <div class="post-image-wrapper">
          <img :src="preview_src" alt="" />
        </div>

        <div class="post-text" v-html="shareTitleToWxImage"></div>

        <div class="bottom-wrapper">
          <div class="left-wrapper" v-html="shareDescToWxImage"></div>
          <img :src="shareQrcodeToWxImage" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VImage from './ponents/VImage/index.vue'
import VButton from './ponents/VButton/index'
import VSwipe from './ponents/VSwipe/index.vue'
import VVideo from './ponents/VVideo/index.vue'
import VDivider from './ponents/VDivider/index.vue'
import DownloadDialog from './ponents/DownloadDialog/index'
import { ImagePreview } from 'vant'
import http from '@/request/index'
import BetterweWxApi from '@/components/wx/control.js'
import ShareComponent from '@/components/app/share/share.vue'
import {
  eventObj as shareEventObj,
  shareImageIcons
} from '@/components/app/share/share-method.js'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
export default {
  name: 'lowcode-active',

  components: {
    VImage,
    VButton,
    VSwipe,
    VVideo,
    VDivider,
    DownloadDialog,
    ShareComponent,
    AppNavbar,
    WxOpenLaunchApp
  },

  props: {},

  data() {
    return {
      lowcodeData: {},
      downloadShow: false,
      shareLink: '',

      isApp: false,

      postShow: false,
      preview_src: '',

      shareTitleToWxImage: '', // 图片正文
      shareDescToWxImage: '', // 图片提示语
      shareQrcodeToWxImage: '',

      shareDescToWxFriend: '',
      shareThumbnailToWxFriend: '',
      shareTitleToWxFriend: '',

      shareThumbnailToWxCircle: '',
      shareTitleToWxCircle: '',

      options: {
        fontSize: '16px'
      },

      showShare: false,
      iconList: [],
      posterUrl: '',
      qrcodeUrl: `${window.location.origin}/lowcode-active?pageid=${this.$route.query.pageid}`, //分享链接
      shareOptions: {
        //分享参数
        url: 'https://wegymercdn.gymcity.com.cn/coach_archives_3.0/75001eabfcf9946972588c205e1c012c.png',
        desc: '分段收费单',
        title: '测试',
        thumbnail:
          'https://wegymercdn.gymcity.com.cn/coach_archives_3.0/75001eabfcf9946972588c205e1c012c.png'
      }
    }
  },

  computed: {
    extinfo() {
      console.log('原始链接 ---> ', `/web?url=${this.qrcodeUrl}`)
      console.log(
        'encode链接 ---> ',
        `/web?url=${encodeURIComponent(this.qrcodeUrl)}`
      )
      return `/web?url=${encodeURIComponent(this.qrcodeUrl)}`
    }
  },

  watch: {},

  async created() {
    http.addDataLog({
      eventk: `luban-${this.$route.query?.pageid}`,
      eventv: this.$route.query?.pageid
    })
    this.isApp = this.$http._isApp()
    await this.loadData()
    document.title = this.lowcodeData?.title || '活动页'
  },

  mounted() {},

  destroyed() {},

  methods: {
    setShareData(info) {
      let wxFriendoptions = {
        title: this.getShareOption(
          'shareTitleToWxFriend',
          info.drawComponentList
        ), // 分享标题
        desc: this.getShareOption(
          'shareDescToWxFriend',
          info.drawComponentList
        ), // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getShareOption(
          'shareThumbnailToWxFriend',
          info.drawComponentList
        ) // 分享图标
      }
      let wxCircleOptions = {
        title: this.getShareOption(
          'shareTitleToWxCircle',
          info.drawComponentList
        ), // 分享标题
        desc: this.getShareOption(
          'shareDescToWxFriend',
          info.drawComponentList
        ), // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getShareOption(
          'shareThumbnailToWxCircle',
          info.drawComponentList
        ) // 分享图标
      }
      BetterweWxApi.setShareData(wxFriendoptions, wxCircleOptions)
    },
    getShareOption(name, list) {
      let res = ''
      if (list && Array.isArray(list)) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i]
          if (item.events && item.events[name]) {
            res = item.events[name]
            break
          }
        }
      }
      return res
    },
    fComponentStyle(component) {
      if (!component || !component.length) {
        return []
      }
      let saveArr = component.map((item) => {
        return {
          ...item,
          style: JSON.parse(item.style)
        }
      })
      return saveArr
    },
    // css计算
    calculateCss(px) {
      let str = ''
      str = `${(px / this.lowcodeData.canvasStyle.width) * 100}vw`
      return str
    },
    fStyle(styles) {
      if (!styles || !Object.keys(styles).length) {
        return
      }
      const styleObj = {}
      Object.keys(styles).forEach((attr) => {
        if (attr === 'rotate') {
          styleObj.transform = `rotate(${styles[attr]}deg)`
        } else if (['fontWeight', 'opacity'].includes(attr)) {
          styleObj[attr] = styles[attr]
        } else if (['backgroundImage'].includes(attr)) {
          styleObj[attr] = `url(${styles[attr]})`
        } else if (
          [
            'fontSize',
            'borderRadius',
            'height',
            'width',
            'left',
            'top',
            'borderWidth',
            'letterSpacing'
          ].includes(attr)
        ) {
          styleObj[attr] = this.calculateCss(styles[attr])
        } else {
          styleObj[attr] = styles[attr]
        }
      })
      return styleObj
    },
    saveImage() {
      this.$toast.loading({
        duration: 0,
        message: '保存中...'
      })
      this.urlToBase64(this.shareLink, (dataURL) => {
        this.$betterwe.onAppSaveImage({
          data: dataURL, //分享的具体数据
          //分享的数据的格式
          //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'base64'
        })
        this.$toast.clear()
      })
    },
    urlToBase64(url, callback = null) {
      let that = this
      let image = new Image()
      image.setAttribute('crossOrigin', 'Anonymous')
      image.src = url + '?v=' + Math.random()

      image.onload = function () {
        let dataURL = that.imageToBase64(image)
        if (callback) {
          callback(dataURL)
        }
      }
    },
    imageToBase64(image) {
      let canvas = document.createElement('canvas')
      let width = image.width
      let height = image.height

      canvas.width = width
      canvas.height = height
      let context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, width, height)
      return canvas.toDataURL('image/png')
    },
    onPlay(componentInfo) {
      if (process.env.NODE_ENV !== 'development') {
        http.addDataLog({
          eventk: `lubanclick-${this.$route.query?.pageid}`,
          eventv: componentInfo.id
        })
      }
    },
    bindCancel() {
      this.iconList = []
      this.postShow = false
    },
    async bindSelect(options) {
      this.iconList = []
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)

      switch (options.id) {
        // 生成图片 base64
        case 1:
          // eslint-disable-next-line no-case-declarations
          let url = await shareEventObj
            .createPoster('a-poster')
            .catch((err) => {
              console.log('err ---> ', err)
            })
          this.postShow = false
          this.iconList = shareImageIcons
          this.posterUrl = url
          this.showShare = true
          break
        // 分享链接到微信好友
        case 2:
          if (
            !this.qrcodeUrl ||
            !this.shareDescToWxFriend ||
            !this.shareThumbnailToWxFriend ||
            !this.shareTitleToWxFriend
          ) {
            this.$toast('请联系工作人员配置完整!')
            return
          }
          shareOptions.url = this.qrcodeUrl
          shareOptions.desc = this.shareDescToWxFriend
          shareOptions.thumbnail = this.shareThumbnailToWxFriend
          shareOptions.title = this.shareTitleToWxFriend
          shareEventObj.shareLinkToWxFriend(shareOptions)
          this.postShow = false
          break
        // 分享链接到微信朋友圈
        case 3:
          if (
            !this.qrcodeUrl ||
            !this.shareTitleToWxCircle ||
            !this.shareThumbnailToWxCircle
          ) {
            this.$toast('请联系工作人员配置完整!')
            return
          }
          shareOptions.url = this.qrcodeUrl
          shareOptions.title = this.shareTitleToWxCircle
          shareOptions.thumbnail = this.shareThumbnailToWxCircle
          shareEventObj.shareLinkToWxCircle(shareOptions)
          this.postShow = false
          break
        case 4:
          break
        // 保存图片到手机
        case 5:
          shareEventObj.saveImageToPhone(this.posterUrl)
          this.postShow = false
          break
        // 分享图片到微信好友 图片 -> base64
        case 6:
          if (
            !this.posterUrl ||
            !this.shareDescToWxFriend ||
            !this.shareThumbnailToWxFriend ||
            !this.shareTitleToWxFriend
          ) {
            this.$toast('请联系工作人员配置完整!')
            return
          }
          shareOptions.url = this.posterUrl
          shareOptions.desc = this.shareDescToWxFriend
          shareOptions.thumbnail = this.shareThumbnailToWxFriend
          shareOptions.title = this.shareTitleToWxFriend
          shareEventObj.shareImageToWxFriend(shareOptions)
          this.postShow = false
          break
        // 分享图片到微信朋友圈 图片 -> base64
        case 7:
          if (
            !this.posterUrl ||
            !this.shareDescToWxFriend ||
            !this.shareThumbnailToWxFriend ||
            !this.shareTitleToWxFriend
          ) {
            this.$toast('请联系工作人员配置完整!')
            return
          }
          shareOptions.url = this.posterUrl
          shareOptions.desc = this.shareDescToWxFriend
          shareOptions.thumbnail = this.shareThumbnailToWxFriend
          shareOptions.title = this.shareTitleToWxFriend
          shareEventObj.shareImageToWxCircle(shareOptions)
          this.postShow = false
          break
      }
    },
    async onEvent(events, componentType, e, componentInfo) {
      if (!events || !Object.keys(events).length) {
        return
      }
      if (process.env.NODE_ENV !== 'development') {
        // 防止在埋点上报前跳转 做延迟
        await http.addDataLog({
          eventk: `lubanclick-${this.$route.query?.pageid}`,
          eventv: componentInfo.id
        })
      }
      if (componentType === 'v-swipe') {
        const componentIndex = Number(e.target.dataset.index) + 1
        if (events[`image-${componentIndex}-eventsType`] === 'share') {
          if (this.$http._isApp()) {
            this.downloadShow = true
            this.shareLink = events[`image-${componentIndex}-shareLink`]
          } else {
            ImagePreview({
              images: [events[`image-${componentIndex}-shareLink`]],
              showIndex: false
            })
          }
        } else if (events[`image-${componentIndex}-eventsType`] === 'newJump') {
          const eventObj = {
            web: () => {
              this.onWebEvent(events[`image-${componentIndex}-link`] || '')
            },
            common: () => {
              this.onAppEvent(events[`image-${componentIndex}-link`])
            }
          }
          eventObj[events[`image-${componentIndex}-type`]] &&
            eventObj[events[`image-${componentIndex}-type`]]()
        } else if (
          events[`image-${componentIndex}-eventsType`] === 'rivateDomainShare'
        ) {
          if (!this.$http._isApp()) {
            this.$toast('请在APP内打开！')
            return false
          }
          this.postShow = true
          this.showShare = true

          // 分享图片
          this.preview_src = this.lowcodeData.preview_src
          this.shareTitleToWxImage = events[
            `image-${componentIndex}-shareTitleToWxImage`
          ]
            ? events[`image-${componentIndex}-shareTitleToWxImage`]
            : ''
          this.shareDescToWxImage = events[
            `image-${componentIndex}-shareDescToWxImage`
          ]
            ? events[`image-${componentIndex}-shareDescToWxImage`]
            : ''
          this.shareQrcodeToWxImage = events[
            `image-${componentIndex}-shareQrcodeToWxImage`
          ]
            ? events[`image-${componentIndex}-shareQrcodeToWxImage`]
            : ''

          // 分享到微信好友

          this.shareDescToWxFriend = events[
            `image-${componentIndex}-shareDescToWxFriend`
          ]
            ? events[`image-${componentIndex}-shareDescToWxFriend`]
            : ''
          this.shareThumbnailToWxFriend = events[
            `image-${componentIndex}-shareThumbnailToWxFriend`
          ]
            ? events[`image-${componentIndex}-shareThumbnailToWxFriend`]
            : ''
          this.shareTitleToWxFriend = events[
            `image-${componentIndex}-shareTitleToWxFriend`
          ]
            ? events[`image-${componentIndex}-shareTitleToWxFriend`]
            : ''

          // 分享到微信朋友圈
          this.shareThumbnailToWxCircle = events[
            `image-${componentIndex}-shareThumbnailToWxCircle`
          ]
            ? events[`image-${componentIndex}-shareThumbnailToWxCircle`]
            : ''
          this.shareTitleToWxCircle = events[
            `image-${componentIndex}-shareTitleToWxCircle`
          ]
            ? events[`image-${componentIndex}-shareTitleToWxCircle`]
            : ''
        } else {
          const eventObj = {
            web: () => {
              this.onWebEvent(events[`image-${componentIndex}-link`] || '')
            },
            micro: () => {
              let link = events[`image-${componentIndex}-link`]
              let sourceLink = events[`image-${componentIndex}-sourceLink`]
              this.onMicroEvent(link, sourceLink)
            },
            app: () => {
              const link = events[`image-${componentIndex}-link`]
              this.onAppEvent(link)
            }
          }
          eventObj[events[`image-${componentIndex}-type`]] &&
            eventObj[events[`image-${componentIndex}-type`]]()
        }
      } else {
        if (events.eventsType === 'share') {
          if (this.$http._isApp()) {
            this.downloadShow = true
            this.shareLink = events?.shareLink
          } else {
            ImagePreview({
              images: [events.shareLink],
              showIndex: false
            })
          }
        } else if (events.eventsType === 'newJump') {
          const eventObj = {
            web: () => {
              this.onWebEvent(events?.link || '')
            },
            common: () => {
              this.onAppEvent(events.link)
            }
          }
          eventObj[events?.type] && eventObj[events?.type]()
        } else if (events.eventsType === 'rivateDomainShare') {
          if (!this.$http._isApp()) {
            this.$toast('请在APP内打开！')
            return false
          }

          this.postShow = true
          this.showShare = true

          // 分享图片
          this.preview_src = this.lowcodeData.preview_src
          this.shareTitleToWxImage = events?.shareTitleToWxImage
            ? events?.shareTitleToWxImage
            : ''
          this.shareDescToWxImage = events?.shareDescToWxImage
            ? events?.shareDescToWxImage
            : ''
          this.shareQrcodeToWxImage = events?.shareQrcodeToWxImage
            ? events?.shareQrcodeToWxImage
            : ''

          // 分享到微信好友
          this.shareDescToWxFriend = events?.shareDescToWxFriend
            ? events?.shareDescToWxFriend
            : ''
          this.shareThumbnailToWxFriend = events?.shareThumbnailToWxFriend
            ? events?.shareThumbnailToWxFriend
            : ''
          this.shareTitleToWxFriend = events?.shareTitleToWxFriend
            ? events?.shareTitleToWxFriend
            : ''

          // 分享到微信朋友圈
          this.shareThumbnailToWxCircle = events?.shareThumbnailToWxCircle
            ? events?.shareThumbnailToWxCircle
            : ''
          this.shareTitleToWxCircle = events?.shareTitleToWxCircle
            ? events?.shareTitleToWxCircle
            : ''
        } else {
          const eventObj = {
            web: () => {
              this.onWebEvent(events?.link || '')
            },
            micro: () => {
              let link = events?.link
              let sourceLink = events?.sourceLink
              this.onMicroEvent(link, sourceLink)
            },
            app: () => {
              this.onAppEvent(events?.link)
            }
          }

          eventObj[events?.type] && eventObj[events?.type]()
        }
      }
    },
    // web跳转事件
    onWebEvent(url) {
      if (!url) return
      if (this.$http._isApp()) {
        this.$betterwe.jumpRoute('/web?url=' + encodeURIComponent(url))
      } else {
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    // 小程序跳转事件
    onMicroEvent(link, sourceLink) {
      if (this.$http._isApp()) {
        let fuhao = '?'
        if (link && link.split('?').length > 1) {
          fuhao = '&'
        }
        let clink = `${link}${fuhao}url=${
          sourceLink ? encodeURIComponent(sourceLink) : ''
        }`
        clink = encodeURIComponent(clink)
        this.$betterwe.onAppPageUrlRoute(
          `/miniProgram?userName=gh_0d804ee2c21b&path=${clink}`
        )
      } else {
        this.$toast('请前往APP打开')
      }
    },
    // app跳转事件
    onAppEvent(link) {
      if (!link) return
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(link)
      } else {
        this.$toast('请前往APP打开')
      }
    },
    // 获取详情
    async loadData() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...'
      })
      let res = await this.$http.getApp('api/v1/LowCode/view', {
        id: this.$route.query?.pageid
      })
      this.$toast.clear()
      if (res.data.code === 200) {
        this.lowcodeData = res.data.data
        this.setShareData(this.lowcodeData)
        this.$betterwe.initWebViewUIConfig({
          title: this.lowcodeData.title || 'betterWE星球'
        })
      }
    },
    onClickBack() {
      if (this.$http._isApp()) {
        this.$http.appBack()
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

::v-deep {
  .van-nav-bar .van-icon {
    color: #000;
    font-size: 4.5vw;
    font-weight: 600;
  }
  .van-nav-bar__text {
    color: #000;
    font-size: vw(16);
  }
  .van-nav-bar__title {
    font-family: PingFangSC-Medium;
    font-size: 4.8vw;
    letter-spacing: -0.2vw;
    color: #000;
    font-weight: 600;
  }
}

.lowcode-active {
  position: relative;
  .component-preview-item {
    position: absolute;
  }
}

.back-float-ball {
  width: vw(50);
  height: vw(50);
  border-radius: 50%;
  background-color: #708eea;
  position: fixed;
  bottom: vw(40);
  right: vw(40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
}

#a-poster {
  background-repeat: no-repeat;
  box-sizing: border-box;
  .blur-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    filter: blur(4px);
  }

  .post-wrapper {
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f62ddcdb94cf0329f7befb0110b2a504.png');
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    z-index: 2;
    .top-info-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 20px 0;
      .left-wrapper {
        display: flex;
        .title-image {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
        .title-desc {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title-desc-1 {
            font-size: 14px;
            font-weight: bold;
            color: #666;
          }
          .title-desc-2 {
            font-size: 12px;
            color: rgb(163, 162, 182);
          }
        }
      }
      .right-wrapper {
        img {
          width: 100px;
        }
      }
    }
    .post-image-wrapper {
      margin: 20px 0;
      overflow: hidden;
      height: 350px;
      padding: 0 20px 0;
      img {
        border-radius: 8px;
        width: 100%;
      }
    }

    .post-text {
      padding: 0 20px 0;
      line-height: 25px;
      color: #666;
    }

    .bottom-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      background-color: rgb(247, 247, 247);
      padding: 10px 20px;
      .left-wrapper {
        color: black;
        line-height: 25px;
      }
      img {
        width: 70px;
      }
    }
  }
}

.download {
  position: sticky;
  width: 100%;
  height: 56px;
  background-color: #fff;
  box-shadow: 0 0.5px 0 #ededed;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  padding: 0px 15px;
  box-sizing: border-box;

  .logo {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }

  .center {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .text1 {
      font-size: 15px;
      line-height: 23px;
    }

    .text2 {
      font-size: 12px;
      line-height: 16px;
      color: #999;
    }
  }

  .btn {
    position: relative;
    width: 72px;
    background: linear-gradient(270deg, #6759ff 0%, #8b75ff 100%);
    height: 26px;
    text-align: center;
    border-radius: 13px;
    line-height: 26px;
    font-size: 13px;
    color: #fff;
  }
}

.download-btn {
  width: 163px;
  height: 40px;
  position: fixed;
  left: 50%;
  bottom: 68px;
  transform: translate(-50%, 0%);
  border-radius: 20px;
  z-index: 999;
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(270deg, #6759ff 0%, #8b75ff 100%);
}
</style>
